export default "__VITE_ASSET__27c7c37a__"